// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1r-q";
export var animationRelative = "_1r-p";
export var backdropBlur = "_1r-0";
export var detailLabelCell = "_1r-12";
export var detailTable = "_1r-11";
export var detailValueCell = "_1r-13";
export var docIconBox = "_1r-1d";
export var docIconBoxMd = "_1r-1f";
export var docIconBoxSm = "_1r-1e";
export var docTypeRow = "_1r-16";
export var docTypeRowInner = "_1r-17";
export var dropdownMatchDatePicker = "_1r-3";
export var evidenceCardContent = "_1r-1c";
export var fileUploadSpin = "_1r-j";
export var gorgiasOpenButton = "_1r-15 _1r-d";
export var gorgiasTicketCard = "_1r-14";
export var heroModalFooterButton = "_1r-18";
export var hiddenContainer = "_1r-o";
export var iconPrimary = "_1r-1g";
export var iconSecondary = "_1r-1h";
export var iconTertiary = "_1r-1i";
export var integrationCard = "_1r-1";
export var integrationLogoBox = "_1r-2";
export var mainColumnSticky = "_1r-1b";
export var maxWidthContainer = "_1r-19";
export var modalContentBody = "_1r-a";
export var modalHeaderImage = "_1r-5";
export var modalImageLabel = "_1r-7";
export var modalImageOverlay = "_1r-6";
export var modalImageSubtitle = "_1r-9";
export var modalImageTitle = "_1r-8";
export var modalImageWrapper = "_1r-4";
export var modalStickyFooter = "_1r-b";
export var removeButton = "_1r-e";
export var sidebarColumn = "_1r-1a";
export var spinner = "_1r-i";
export var timelineLine = "_1r-y";
export var timelineLineBlack = "_1r-10 _1r-y";
export var timelineLineGray = "_1r-z _1r-y";
export var timelineLineHeight = "_1r-x";
export var tlDotActivate = "_1r-u";
export var tlDotActivateAnim = "_1r-t";
export var tlDotHide = "_1r-s";
export var tlDotHideAnim = "_1r-r";
export var tlLineActivate = "_1r-w";
export var tlLineActivateAnim = "_1r-v";
export var uploadHint = "_1r-n";
export var uploadIconBox = "_1r-k";
export var uploadLabel = "_1r-m";
export var uploadText = "_1r-l";
export var uploadZone = "_1r-f";
export var uploadZoneCursorDefault = "_1r-h";
export var uploadZoneCursorPointer = "_1r-g";
export var uploadedFileRow = "_1r-c";
export var viewButton = "_1r-d";